<template>
  <div v-loading="loading">
    <pt-page-title :title="`${isEdit ? '编辑' :'新建'}积分任务`"></pt-page-title>
    <pt-integral-task-form ref="form" class="pt-integral-task-form__withData" v-model="currentForm"></pt-integral-task-form>
    <div class="button-div">
      <el-button type="primary" @click="save">确认</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
      <el-button type="danger" :plain="isEnabled ? false:true" @click="handleStatus">{{isEnabled? '暂停' : '恢复'}}</el-button>
    </div>
  </div>
</template>

<script>
import PtIntegralTaskForm from './index'
export default {
  name: 'pt-integral-task-form__withData',
  components: {
    'pt-integral-task-form': PtIntegralTaskForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    },
    isEnabled () {
      return this.currentForm.status === 'ENABLED'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {}
    }
  },
  methods: {
    save () {
      this.$refs.form.validate().then(formValue => {
        this.loading = true
        console.log('currentForm======', this.currentForm)
        // this.changeForm()
        this.isEdit ? this.edit() : this.create()
      })
    },
    create () {
    },
    edit () {
      console.log('this.changeForm()-------', this.currentForm)
      this.$store.dispatch('udpateIntegralTask', this.currentForm).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    load () {
      this.loading = true
      this.$store.dispatch('getIntegralTask', this.$route.params.id).then(data => {
        this.currentForm = data
        this.loading = false
        console.log('====currentForm', this.currentForm)
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    // 处理当前积分任务暂停／启用
    handleStatus () {
      this.loading = true
      let api = this.isEnabled ? 'disabledIntegralTask' : 'enabledIntegralTask'
      this.$store.dispatch(api, this.$route.params.id).then(data => {
        this.load()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
<style lang="less">
.button-div{
  .el-button--danger.is-plain:hover, .el-button--danger.is-plain:focus{
    color: #f56c6c !important;
    background: #fef0f0!important;
    border-color: #fbc4c4!important;
  }
}

</style>
